module.exports = "<div class=\"modal-content modal-forms\">\n  <div class=\"loadingContainer\">\n    <div class=\"block-ui-overlay\"></div>\n    <div class=\"block-ui-message-container\" aria-live=\"assertive\" aria-atomic=\"true\">\n      <div class=\"loader\"><span></span><span></span><span></span></div>\n    </div>\n  </div>\n  <div class=\"loadingText\">Cargando...</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cargando/cargando.component.html
// module id = ./src/app/cargando/cargando.component.html
// module chunks = main